import useCacheAdoption from '@/hooks/useCacheAdoption';
import usePagination, { useQueryType } from '@/hooks/usePagination';
import { ActionItemsFilters } from '@/types/schema';
import * as Urql from '@/utils/urql';

import {
  ActionItemsQuery,
  ActionItemsQueryVariables,
  useActionItemsQuery,
} from '../graphql/queries/generated/actionItems';

const useActionItems = ({
  sort,
  pageSize,
  filters,
  useQuery = useActionItemsQuery,
  requestPolicy = 'cache-and-network',
}: {
  sort?: ActionItemsQueryVariables['sort'];
  pageSize?: number;
  filters?: ActionItemsFilters | null;
  useQuery?: useQueryType<ActionItemsQuery, ActionItemsQueryVariables>;
  requestPolicy?: Urql.UseQueryArgs['requestPolicy'];
}) => {
  const { isLoading, error, fetchMore, data, refetch, isFetchingMore, totalCount, setAfter } =
    usePagination(
      useQuery,
      {
        filters,
        sort,
      },
      {
        edgeKey: 'actionItems',
        requestPolicy,
        pageSize,
        // pause: !entity && !parentId,
      },
    );

  const cachedActionItems = useCacheAdoption(data);

  return {
    fetching: isLoading,
    error,
    actionItems: data?.length ? data : undefined,
    fetchMore,
    refetch,
    isFetchingMore,
    totalCount,
    setAfter,
  };
};

export default useActionItems;
